import { Branding } from '@/features/branding/ui/Branding';

/**
 * §5: a page composes, it does not implement.
 */
export function BrandingPage() {
  return <Branding />;
}
